import { createSelector } from 'reselect';

const getNotification = (state) => state.ui.notifications.notifications;
export const selectNotifications = createSelector([getNotification], (notifications) =>
  notifications.concat([]).reverse()
);
